import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import logger from 'redux-logger';

const isProd = process.env.NODE_ENV === 'production';

export const store = configureStore({
  reducer: rootReducer,
  devTools: !isProd,
  middleware: (getDefaultMiddleware) => {
    const base = getDefaultMiddleware({
      serializableCheck: {},
      immutableCheck: !isProd,
    });
    if (!isProd) {
      return base.concat(logger);
    }

    return base;
  },
  preloadedState: {},
});

export default store;
